module.exports = __webpack_public_path__ + "static/che12-2f08c6c14c9417f55d82e54ffca2999e.jpg";